import styled from "styled-components";

export const SearchBoxStyled = styled.div`
  position: absolute;
  z-index: 2;
  top: 24px;
  right: 36px;
  width: 270px;
  height: 42px;
  border-radius: 14px;
  overflow: hidden;


  & > input {
    padding: 6px 9px;
  }

  .search-box__icon {
    position: absolute;
    top: 9px;
    left: 6px;
  }
`;
export const CloseBtn = styled.div`
  opacity: 0.6;
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  & > :first-child {
    width: 20px;
    height: 20px;
  }
`;
